import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { BoostSolidIconBrand } from 'src/svgs/BoostSolidIconBrand';
import { BoostSolidIconWhite } from 'src/svgs/BoostSolidIconWhite';
import { PosIconProps } from 'src/svgs/SvgWrapper';

export const BoostSolidIconDisplay = (
  props: Omit<PosIconProps, 'viewBox' | 'fill' | 'stroke'> & {
    inactive?: boolean;
  }
) => {
  const { isDarkMode } = useSiteTheme();

  return isDarkMode ? (
    <BoostSolidIconWhite {...props} />
  ) : (
    <BoostSolidIconBrand {...props} />
  );
};
